// const popoverTriggerList = document.querySelectorAll(
//     '[data-bs-toggle="popover"]'
// );
// const popoverList = [...popoverTriggerList].map(
//     (popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl)
// );

// const PAGE_BUTTON_CLASS = "btn btn-secondary page-button shadow-sm";
// const SCROLL_UP_ATTRIBUTE = "up";
// const SCROLL_DOWN_ATTRIBUTE = "down";

// function createPageButton() {
//     const button = document.createElement("button");
//     const svgArrow = document.createElementNS(
//         "http://www.w3.org/2000/svg",
//         "svg"
//     );
//     svgArrow.setAttribute("viewBox", "0 0 24 24");
//     svgArrow.setAttribute("width", "24");
//     svgArrow.setAttribute("height", "24");

//     const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
//     path.setAttribute(
//         "d",
//         "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z"
//     );

//     svgArrow.appendChild(path);
//     button.appendChild(svgArrow);

//     button.classList.add(...PAGE_BUTTON_CLASS.split(" "));
//     document.body.appendChild(button);
//     return button;
// }

// function scrollToTop() {
//     window.scrollTo({ top: 0, behavior: "smooth" });
// }

// function scrollToBottom() {
//     window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
// }

// function updateButtonVisibility() {
//     const button = document.querySelector(
//         `.${PAGE_BUTTON_CLASS.split(" ").join(".")}`
//     );
//     if (document.body.scrollHeight > window.innerHeight) {
//         button.style.display = "flex";
//     } else {
//         button.style.display = "none";
//     }
// }

// function updateScrollDirection(button) {
//     const scrollDirection =
//         window.scrollY > 0 ? SCROLL_UP_ATTRIBUTE : SCROLL_DOWN_ATTRIBUTE;
//     button.dataset.scroll = scrollDirection;

//     // Clear existing content
//     button.innerHTML = "";

//     // Create and append the SVG arrow
//     const svgArrow = document.createElementNS(
//         "http://www.w3.org/2000/svg",
//         "svg"
//     );
//     svgArrow.setAttribute("viewBox", "0 0 24 24");
//     svgArrow.setAttribute("width", "24");
//     svgArrow.setAttribute("height", "24");

//     const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
//     path.setAttribute(
//         "d",
//         scrollDirection === SCROLL_UP_ATTRIBUTE
//             ? "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z"
//             : "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z"
//     );

//     svgArrow.appendChild(path);
//     button.appendChild(svgArrow);
// }

// const pageButton = createPageButton();

// pageButton.addEventListener("click", function () {
//     updateScrollDirection(pageButton); // Update SVG immediately
//     const scrollDirection = this.dataset.scroll;
//     if (scrollDirection === SCROLL_UP_ATTRIBUTE) {
//         scrollToTop();
//     } else if (scrollDirection === SCROLL_DOWN_ATTRIBUTE) {
//         scrollToBottom();
//     }
// });

// window.addEventListener("scroll", updateButtonVisibility);
// pageButton.addEventListener("mouseenter", function () {
//     updateScrollDirection(this);
// });

// document.addEventListener("DOMContentLoaded", function () {
//     // Initial update of button visibility
//     updateButtonVisibility();

//     // Initial update of scroll direction
//     updateScrollDirection(pageButton);
// });

const PAGE_BUTTON_CLASS = "page-button btn btn-secondary shadow-sm";
const SCROLL_UP = "up";
const SCROLL_DOWN = "down";

const createPageButton = () => {
    const button = document.createElement("button");

    // Option 1: Split class names and add them individually
    const classList = PAGE_BUTTON_CLASS.split(" ");
    button.classList.add(...classList);

    // Option 2: Use constructor options with class name string
    // button.className = PAGE_BUTTON_CLASS; // Uncomment if using this option

    button.dataset.scroll = SCROLL_UP; // Set default scroll direction

    // Create and append SVG arrow for initial state (up)
    const svgArrow = createSvgArrow(SCROLL_UP);
    button.appendChild(svgArrow);

    document.body.appendChild(button);
    return button;
};

const createSvgArrow = (direction) => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("width", "24");
    svg.setAttribute("height", "24");

    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute(
        "d",
        direction === SCROLL_UP
            ? "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z"
            : "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 0 1 1.06 1.06l-7.5 7.5Z"
    );

    svg.appendChild(path);
    return svg;
};

const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

const scrollToBottom = () =>
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });

const updateButtonVisibility = () => {
    const shouldShow = document.body.scrollHeight > window.innerHeight;
    pageButton.style.display = shouldShow ? "flex" : "none";
};

const updateScrollDirection = () => {
    const scrollDirection = window.scrollY > 0 ? SCROLL_UP : SCROLL_DOWN;
    pageButton.dataset.scroll = scrollDirection;

    // Update the SVG arrow based on new direction
    pageButton.firstChild.replaceWith(createSvgArrow(scrollDirection));
};

const pageButton = createPageButton();

pageButton.addEventListener("click", () => {
    const scrollDirection = pageButton.dataset.scroll;
    if (scrollDirection === SCROLL_UP) {
        scrollToTop();
    } else if (scrollDirection === SCROLL_DOWN) {
        scrollToBottom();
    }
});

window.addEventListener("scroll", updateButtonVisibility);
pageButton.addEventListener("mouseenter", updateScrollDirection);

document.addEventListener("DOMContentLoaded", () => {
    updateButtonVisibility();
    updateScrollDirection();
});


document.addEventListener("DOMContentLoaded", function () {
    const expandAllBtn = document.getElementById("expandAll");
    const collapseAllBtn = document.getElementById("collapseAll");
    const accordions = document.querySelectorAll(".accordion-collapse");
    if (expandAllBtn) {  // Ensure 'button' is not null

        expandAllBtn.addEventListener("click", function () {
            accordions.forEach((accordion) => {
                if (!accordion.classList.contains("show")) {
                    const collapseInstance = new bootstrap.Collapse(accordion, {
                        toggle: false,
                    });
                    collapseInstance.show();
                }
            });
        });
    }
    if (collapseAllBtn) {
        collapseAllBtn.addEventListener("click", function () {
            accordions.forEach((accordion) => {
                if (accordion.classList.contains("show")) {
                    const collapseInstance = new bootstrap.Collapse(accordion, {
                        toggle: false,
                    });
                    collapseInstance.hide();
                }
            });
        });
    }

});

// Immediately Invoked Function Expression (IIFE) to avoid polluting the global scope
(function() {
    // Function to handle quantity changes
    function handleQuantityChange(input, increment) {
        let value = parseInt(input.value, 10);
        if (isNaN(value)) value = 0;

        if (increment) {
            value++;
        } else {
            value = Math.max(1, value - 1); // Ensure the value doesn't go below 1
        }

        input.value = value;

        // Dispatch a custom event in case other parts of the application need to react to this change
        input.dispatchEvent(new CustomEvent('quantityChanged', { bubbles: true, detail: { value: value } }));
    }

    // Function to set up quantity input functionality
    function setupQuantityInput(container) {
        const decrementBtn = container.querySelector('.btn-decrement');
        const incrementBtn = container.querySelector('.btn-increment');
        const input = container.querySelector('input[type="number"]');

        if (!decrementBtn || !incrementBtn || !input) return;

        decrementBtn.addEventListener('click', () => handleQuantityChange(input, false));
        incrementBtn.addEventListener('click', () => handleQuantityChange(input, true));

        // Optional: Handle direct input changes
        input.addEventListener('change', () => {
            let value = parseInt(input.value, 10);
            if (isNaN(value) || value < 1) {
                input.value = 1;
            }
        });
    }

    // Function to initialize all quantity inputs on the page
    function initializeQuantityInputs() {
        const quantityContainers = document.querySelectorAll('.quantity-input-container');
        quantityContainers.forEach(setupQuantityInput);
    }

    // Set up a MutationObserver to handle dynamically added quantity inputs
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.classList.contains('quantity-input-container')) {
                            setupQuantityInput(node);
                        } else {
                            const containers = node.querySelectorAll('.quantity-input-container');
                            containers.forEach(setupQuantityInput);
                        }
                    }
                });
            }
        });
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, { childList: true, subtree: true });

    // Initialize existing quantity inputs when the DOM is fully loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeQuantityInputs);
    } else {
        initializeQuantityInputs();
    }
})();



